var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { AlertTriangleIcon, Label, translate, } from '@lucidlink/uicore';
export const StatusTextError = ({ anchorRef, 'data-testid': testId, }) => {
    return (_jsx(Label, { color: 'static_error', "data-testid": testId, ref: anchorRef, StartIcon: AlertTriangleIcon, text: translate('Error') }));
};
_react_refresh_temp_1 = StatusTextError;
$RefreshReg$(_react_refresh_temp_1, "StatusTextError");
